import allowedFramedUrls, { clickableClasses } from './allowedFramedUrls';

export function urlMessenger(targetUrl, event) {
  event.preventDefault();
  window.top.postMessage({
    messageId: 'LOGIN_NAV',
    status: 'Canceled',
    target: targetUrl,
  }, '*');
  return targetUrl;
}

// will traverse parent elements up to grandparent
export function onFrameClick(e) {
  let node = e.target;

  // urls allowed to navigate within the Iframe --> /src/allowedFramedUrls.js
  const [allowed] = allowedFramedUrls.filter((link) => {
    if (node.href) {
      return node.href.includes(link);
    }
    return false;
  });

  if (allowed) {
    return true;
  }
  // clickabled icons to be handled by className --> /src/allowedFramedUrls.js
  const foundClassNameValue = Object.keys(clickableClasses).reduce(
    (result, key) => (node.className.includes(key) ? clickableClasses[key] : result),
    ''
  );
  if (foundClassNameValue) {
    return urlMessenger(foundClassNameValue, e);
  }

  while (node) {
    if (node.href) {
      return urlMessenger(node.href, e);
    }
    node = node.parentElement;
  }
  return true;
}

export function unloadHandler(event) {
  event.preventDefault();
  // eslint-disable-next-line no-param-reassign -- legacy browsers require reassignment of returnValue property to prevent navigating away
  event.returnValue = '';
  return event.returnValue;
}

export function eventDelegator(document) {
  document.addEventListener('click', onFrameClick);
}
